import React, { useCallback, useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from "prop-types";
import { isDate, isString, isNumber } from "lodash";
import moment from "moment";


import {
    TimelineLegendContainer,
    TimelineLegendUpperLabelLeft,
    TimelineLegendUpperLabelRight,
    TimelineLegendLowerLabel,
    TimelineLegendConstants,
} from './TimelineLegend.Styled';


function TimelineLegend(props) {

    const containerRef = useRef();
    const observerRef = useRef();
    const internalsRef = useRef({
        lastWidth:-1,
    });

    const [ state, setState ] = useState({
        svgPath:'',
        svgWidth:0,
        svgHeight:0,
        upperLabels:undefined,
        lowerLabels:undefined
    });


    const toDateString = (date) => {
        const d = `00${date.date()}`;
        const m = `00${date.month()+1}`;
        const w = `00${date.isoWeek()}`;
        return d.substring(d.length - 2) + '.' +
            m.substring(m.length - 2) + ' W' +
            w.substring(w.length - 2)
            ;
    };

    const toDateWeekString = (date) => {
        const w = `00${date.isoWeek()}`;
        return 'W' + w.substring(w.length - 2);
    };

    const tlH = 6;

    const beakH = 8;
    const beakW = 6;
    const beakWHalf = 3;

    const generateContent = useCallback((width = -1) => {
        const w = width - 32;
        const startDate = moment(props.startDate);
        const endDate = moment(props.endDate);
        const interval = moment.duration(endDate.diff(startDate));
        const weeks = interval.asWeeks() - 1;
        const iweeks = Math.ceil(weeks);

        const upperLabels = (
            <>
            <TimelineLegendUpperLabelLeft>{toDateString(startDate)}</TimelineLegendUpperLabelLeft>
            <TimelineLegendUpperLabelRight>{toDateString(endDate)}</TimelineLegendUpperLabelRight>
            </>
        );
        let lowerLabels = [];

        let path =
            `M${beakW+1},${tlH+1}`+
            `l${w-2*beakW-2},0`+
            `l${beakW},${beakH}`+
            `l0,${-(beakH+tlH)}`+
            `l${-(w-2)},0`+
            `l0,${tlH+beakH}z`
        ;

        if (iweeks > 1) {
            let wd = moment(startDate).add(1, "w");
            path =
                `M${beakW+1},${tlH+1}`
            ;

            let x = beakW+1;
            let bx = 1;
            let l = w-2*beakW-2;
            let wDist = l / iweeks;
            let dw = 1;
            // if (wDist < 32 && iweeks > 3) {
            //     wDist = l / Math.floor(iweeks / 2);
            //     dw = 2
            // }

            for (let wi = 0; wi < iweeks-dw; wi += dw) {
                bx += wDist;

                path += `l${(bx-x-beakWHalf).toFixed(2)},0l${beakWHalf},${beakH}l${beakWHalf},${-beakH}`;

                x = bx + beakWHalf;

                lowerLabels.push({position:bx, week:moment(wd)});
                wd = wd.add(dw, "w");
            }

            path += `l${(w-2-x-beakW).toFixed(2)},0`;

            path +=
                `l${beakW},${beakH}`+
                `l0,${-(beakH+tlH)}`+
                `l${-(w-2)},0`+
                `l0,${tlH+beakH}z`
            ;
        }

        setState(old => ({
            ...old,
            upperLabels:upperLabels,
            lowerLabels:lowerLabels.map((ll, i) => (
                <TimelineLegendLowerLabel
                    key={`LLB-${i}`}
                    style={{ transform:`matrix(1,0,0,1,${ll.position-12},0)` }}
                >
                    {toDateWeekString(ll.week)}
                </TimelineLegendLowerLabel>)
            ),
            svgPath:path,
            svgWidth:w,
            svgHeight:tlH+beakH+2
        }));
    }, [props.startDate, props.endDate, setState]);


    const onResize = (entries) => {
        const w = entries[0].contentRect.width;
        generateContent(w);
    };


    useEffect(() => {
        observerRef.current = new ResizeObserver(onResize);

        observerRef.current.observe(containerRef.current);

        return () => {
            observerRef.current.disconnect();
        }
    }, []);


    useEffect(() => {
        generateContent(containerRef.current.getBoundingClientRect().width);
    }, [props.startDate, props.endDate, setState]);


    return (
        <TimelineLegendContainer
            id={"timeline-legend-container"}
            ref={containerRef}
            style={{
            }}
        >
            <div style={{
                position:'absolute',
                left:16, top:4,
                width:'calc(100% - 32px)',
                height:60,
                display:'flex',
                flexDirection:'column',
            }}>
                <div style={{width:'100%', height:20}}>
                    {state.upperLabels}
                </div>
                <div style={{width:'100%', height:20}}>
                    <svg width={`${state.svgWidth}px`} height={`${state.svgHeight}px`}>
                        <path d={state.svgPath}
                              style={{
                                  fill:'#667399',
                                  stroke:'#282828',
                                  strokeWidth:'1px',
                              }}/>
                    </svg>
                </div>
                <div style={{position:'relative', width:'100%', height:18}}>
                    {state.lowerLabels}
                </div>
            </div>

        </TimelineLegendContainer>
    );
}


TimelineLegend.propTypes = {
    id:PropTypes.string,
    startDate:PropTypes.string.isRequired,
    endDate:PropTypes.string.isRequired,
};


TimelineLegend.defaultProps = {
    startDate:'2020-03-12',
    endDate:'2020-11-25',
};


export default TimelineLegend;
